import { ApiFilestackImageWithTextData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { imageUrl } from 'utils/filestack';

import {
  CmsImageBlockImageHolder,
  GifImage,
} from './CmsImageBlockImage.styled';

type Props = {
  image: ApiFilestackImageWithTextData;
  keepDimensions: boolean;
  fullWidthLayout: boolean;
};

export function CmsImageBlockImage({
  image,
  keepDimensions,
  fullWidthLayout,
}: Props) {
  const { mimetype, altText } = image;
  const isGif = mimetype === 'image/gif';

  if (isGif) {
    return (
      <GifImage
        src={imageUrl({
          data: image,
          width: undefined,
          height: undefined,
          fit: 'max',
          insecureSVG: false,
        })}
        alt={altText || ''}
        $fullWidthLayout={fullWidthLayout}
      />
    );
  }

  return (
    <CmsImageBlockImageHolder $keepDimensions={keepDimensions}>
      <FilestackImage
        data-qa-id="cms-image-block-image"
        data={image}
        width={keepDimensions ? undefined : 1152}
        objectPosition="left"
        insecureSVG
      />
    </CmsImageBlockImageHolder>
  );
}
